var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapMousePosition",staticClass:"map-control d-flex align-center justify-center map-mouse-position",style:({ top: _vm.top, bottom: _vm.bottom, left: _vm.left, right: _vm.right })},[_c('v-icon',{attrs:{"color":"rgba(94, 86, 105, 0.68)","size":"14"}},[_vm._v(_vm._s(_vm.icons.mdiCrosshairsGps))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }